if (!customElements.get('tsl-offer-carousel')) {
  customElements.define('tsl-offer-carousel', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('.tsl-offer-carousel__rail');
      this.cards = [...this.rail.children];
      this.controls = this.querySelector('.tsl-offer-carousel__controls');
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.position = this.querySelector('[data-position]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous.addEventListener('click', () => this.go(this.index - 1), options);
      this.next.addEventListener('click', () => this.go(this.index + 1), options);
      this.rail.addEventListener('scroll', () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.rail.addEventListener('keydown', event => {
        if (event.target !== this.rail || this.rail.scrollWidth <= this.rail.clientWidth + 1) return;
        if (['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : event.key === 'End' ? this.cards.length - 1 : this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      }, options);
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.tsl-offer-card');
        if (card) this.go(this.cards.indexOf(card));
      }, options);
      this.resize = new ResizeObserver(() => this.update());
      this.resize.observe(this.rail);
      this.update();
    }
    update() {
      const start = this.rail.getBoundingClientRect().left;
      let distance = Infinity;
      this.index = 0;
      this.cards.forEach((card, index) => {
        const delta = Math.abs(card.getBoundingClientRect().left - start);
        if (delta < distance) { distance = delta; this.index = index; }
      });
      // The final card can stop short of the left edge to keep the end of the rail flush.
      if (this.rail.scrollLeft > 0 && this.rail.scrollLeft + this.rail.clientWidth >= this.rail.scrollWidth - 2) this.index = this.cards.length - 1;
      this.controls.hidden = this.rail.scrollWidth <= this.rail.clientWidth + 1;
      this.previous.disabled = this.index === 0;
      this.next.disabled = this.index === this.cards.length - 1;
      this.position.textContent = `${this.index + 1} / ${this.cards.length}`;
    }
    go(index) {
      const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
      if (!card) return;
      const left = card.getBoundingClientRect().left - this.rail.getBoundingClientRect().left + this.rail.scrollLeft;
      this.rail.scrollTo({left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
